"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _glReact = require("gl-react");

var _ImageTextureLoader2 = require("./ImageTextureLoader");

var _ImageTextureLoader3 = _interopRequireDefault(_ImageTextureLoader2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DeprecatedUriImageTextureLoader = function (_ImageTextureLoader) {
  _inherits(DeprecatedUriImageTextureLoader, _ImageTextureLoader);

  function DeprecatedUriImageTextureLoader() {
    _classCallCheck(this, DeprecatedUriImageTextureLoader);

    return _possibleConstructorReturn(this, (DeprecatedUriImageTextureLoader.__proto__ || Object.getPrototypeOf(DeprecatedUriImageTextureLoader)).apply(this, arguments));
  }

  _createClass(DeprecatedUriImageTextureLoader, [{
    key: "canLoad",
    value: function canLoad(obj) {
      return (typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object" && typeof obj.uri === "string";
    }
  }, {
    key: "get",
    value: function get(obj) {
      return _get(DeprecatedUriImageTextureLoader.prototype.__proto__ || Object.getPrototypeOf(DeprecatedUriImageTextureLoader.prototype), "get", this).call(this, obj.uri);
    }
  }, {
    key: "load",
    value: function load(obj) {
      console.warn("gl-react-dom: usage of {uri} format in texture uniform is deprecated. Directly give an image URL instead.");
      return _get(DeprecatedUriImageTextureLoader.prototype.__proto__ || Object.getPrototypeOf(DeprecatedUriImageTextureLoader.prototype), "load", this).call(this, obj.uri);
    }
  }]);

  return DeprecatedUriImageTextureLoader;
}(_ImageTextureLoader3.default);

_glReact.TextureLoaders.add(DeprecatedUriImageTextureLoader);
//# sourceMappingURL=legacy.js.map


//////////////////
// WEBPACK FOOTER
// ./~/gl-react-dom/lib/legacy.js
// module id = 174
// module chunks = 0